<template>
    <div class="user-account-header">
        <div class="static-pages-title">
            <!-- title -->
            <div class="container">
                <div class="title text-normal">
                    <h1 class="text-white">MY NZXT ACCOUNT</h1>
                </div>
            </div>
            <!-- /.title -->
        </div>
        <!-- Welcome Title with User Name -->
        <div class="welcome-title">
            <div class="container">
                <div class="title text-light">
                    <h1 class="text-white">WELCOME, {{ user.username | upperCase }}</h1>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "user-account-header",
    data() {
        return {}
    },
    props: {
        user: {
            type: Object,
            default: 'USERNAME'
        }
    }
}
</script>
